const langLabels = {
  template: {
    templateCode: '模板编码',
    templateName: '模板名称',
    filePath: '文件路径',
    remark: '模板备注',
    state: '状态',
    createTime: '创建时间',
    templateNamePlaceholder: '请输入模版名称'
  }
}
export default langLabels
